import { AdornedInput } from '@zillow/constellation';
import styled from 'styled-components';

export const FlexGrowAdornedInput = styled(AdornedInput)`
  flex-grow: 1;
`;
